import { Select } from '@mantine/core';
import { useEffect, useRef, useState } from 'react';
import useFetch from '../../helpers/useFetch';

const DomainSecretSelect = ({
  value,
  onChange,
  accountId,
  domainId,
  placeholder,
  onError,
  refreshKey,
  label,
  description,
  error,
  required,
  disabled,
}) => {
  const fetch = useFetch();
  const [secrets, setSecrets] = useState([]);
  // Kept out of the effect's dependencies: a caller passing an inline arrow would
  // otherwise re-read /secrets on every render of the form around the picker.
  const onErrorRef = useRef(onError);
  onErrorRef.current = onError;

  useEffect(() => {
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/secrets`)
      .then(({ secrets }) => setSecrets(secrets))
      .catch((err) => onErrorRef.current?.(err));
  }, [accountId, domainId, fetch, refreshKey]);

  const selectedValue = value ? String(value) : null;

  return (
    <Select
      label={label}
      description={description}
      error={error}
      required={required}
      disabled={disabled}
      placeholder={placeholder}
      clearable
      // A revoked secret is not offered for a new selection, but the one this form
      // already holds stays in the list (labelled revoked) — dropping it would make
      // the Select render blank, which reads as an empty field rather than as a
      // credential that was withdrawn after the form was saved.
      data={secrets
        .filter((s) => !s.revokedAt || String(s.id) === selectedValue)
        .map((s) => ({
          value: String(s.id),
          label: `${s.name} (${s.type === 'token_refresh' ? 'Token Refresh' : 'Static'})${
            s.revokedAt ? ' — revoked' : ''
          }`,
        }))}
      value={selectedValue}
      onChange={(selected) => onChange(selected ? parseInt(selected) : null)}
    />
  );
};

export default DomainSecretSelect;
